/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import "../../styles/table.css";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { listAllOffer, deleteOffer } from "../../services/offerService";
import {
  appointmentService,
  deleteAppointment,
} from "../../services/appointmentService";
import Loader from "../../shared/components/Loader";
import { Sample } from "../../assets/images";
// import Pagination from "../../shared/components/Pagination";
import { NoData } from "../../assets/images/index";
import { toastMessage } from "../../shared/components/Toast";
import { useLogoutHelper, pageLmitConver } from "../../utils/helper";
import { ModeEdit, Delete, Visibility, Add } from "@mui/icons-material";
import ViewDetail from "../../shared/Modals/ViewDetails";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import useDebounce from "../../hooks/debounce";
import moment from "moment/moment";
import Pagination from "../../shared/components/customPaginate/customPagination.jsx";
import NewCar from "../../assets/images/new_car.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import ResponsiveEntityCard from "../../shared/components/ResponsiveEntityCard";
export default function Appointment() {
  const isCompactLayout = useMediaQuery("(max-width:1024px)");
  let types = {
    single: "single",
    multiple: "multiple",
  };
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(true);
  const [allAppointment, setAllAppintment] = useState([]);
  const [lastPage, setLastPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [changePage, seChngetPage] = useState(1);
  const [active, setActive] = useState(1);
  const [allId, setAllId] = useState([]);
  const [appointmentDetail, setAppointmentDetail] = useState({});
  const [openDetail, setOpenDetail] = useState(false);
  const [delLoader, setDelLoader] = useState(false);
  const [delIndx, setDelIndx] = useState(-1);
  const { handleLogout } = useLogoutHelper();

  const getDonor = () => {
    // no dates => all-time (backend defaults the range). Pass picker dates to scope.
    const filters = {};
    if (fromDate) filters.fromDate = fromDate;
    if (toDate) filters.toDate = toDate;
    let obj = {
      page: changePage,
      limit: 10,
      filters,
    };
    if (searchText) {
      obj["search"] = searchText;
    }

    // let query = `?page=${changePage}&limit=10${searchText ? "&search=" + searchText : ""} `;
    setLoader(true);
    appointmentService(obj)
      .then(({ data } = data) => {
        setLoader(false);
        setTotalCount(data?.total || 0);
        if (data?.total > 10) {
          setLastPage(pageLmitConver(data?.total));
        } else {
          setLastPage(1);
        }
        setAllAppintment(data?.appointments);
      })
      .catch((err) => {
        toastMessage(err?.message, "error");
        setLoader(false);
        if (err?.response?.status == 401) {
          handleLogout();
        }
      });
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const changCheckBox = (boxId) => {
    let cloneId = [...allId];
    let checkIndx = allId.findIndex((ii) => ii == boxId?._id);
    if (checkIndx > -1) {
      cloneId.splice(checkIndx, 1);
      setAllId(cloneId);
    } else {
      cloneId.push(boxId?._id);
      setAllId(cloneId);
    }
  };
  // useEffect(() => {
  //   getDonor();
  // }, []);
  const selectAll = () => {
    if (allId.length < 1) {
      let allids = allAppointment.map((ii) => ii?._id);
      setAllId(allids);
    } else {
      setAllId([]);
    }
  };
  const handleClickOpenDetail = (user) => {
    setOpenDetail(true);
    setAppointmentDetail(user);
  };

  const handleCloseDetail = () => {
    setOpenDetail(false);
  };
  const handleDelete = (type, ids) => {
    let cloneAllAppointment = [...allAppointment];

    if (type == types.single) {
      setDelLoader(true);

      deleteAppointment(ids)
        .then(({ data: { message } }) => {
          let checkIndx = cloneAllAppointment.findIndex((ii) => ii?._id == ids);
          if (checkIndx > -1) {
            cloneAllAppointment.splice(checkIndx, 1);
            setAllAppintment(cloneAllAppointment);
          }
          toastMessage(message, "success");
          //remove select id from state
          if (allId?.length) {
            let cloneAllIds = [...allId];
            let checkIdIndx = cloneAllIds.findIndex((ii) => ii == ids);
            if (checkIdIndx > -1) {
              cloneAllIds.splice(checkIdIndx, 1);
              setAllId(cloneAllIds);
            }
          }
        })
        .catch((err) => {
          toastMessage(err.response.data.message, "error");
        })
        .finally(() => setDelLoader(false));
    } else {
      setDelLoader(true);
      deleteAppointment(allId?.toString())
        .then(({ data: { message } }) => {
          for (let index = 0; index < allId.length; index++) {
            const element = allId[index];
            let checkIndx = cloneAllAppointment.findIndex(
              (ii) => ii?._id == element
            );
            if (checkIndx > -1) {
              cloneAllAppointment.splice(checkIndx, 1);
            }
          }
          setAllId([]);
          setAllAppintment(cloneAllAppointment);

          toastMessage(message, "success");
        })
        .catch((err) => {
          toastMessage(err.response.data.message, "error");
        })
        .finally(() => setDelLoader(false));
    }
  };
  useDebounce(
    () => {
      setLoader(true);
      getDonor();
    },
    [searchText, changePage, fromDate, toDate],
    800
  );

  const renderCompactAppointmentActions = (row, index) => (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<Visibility />}
        onClick={() => handleClickOpenDetail(row)}
      >
        Details
      </Button>
      <Button
        size="small"
        color="error"
        variant="outlined"
        startIcon={<Delete />}
        onClick={() => {
          setDelIndx(index);
          handleDelete(types.single, row?._id);
        }}
      >
        Delete
      </Button>
    </>
  );

  return (
    <>
      <div className="flex spaceBetween itemCenter">
        <Typography
          sx={{
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: 32,
            lineHeight: "48px",
            letterSpacing: "-0.5px",
            color: "#11142D",
            marginBottom: "2%",
          }}
        >
          All Appointments
        </Typography>
        <div>
          {allId.length > 1 ? (
            <Button
              sx={{
                background: " rgba(255, 183, 190, 0.9);",
                color: "red",
                marginRight: "10px",
              }}
              onClick={() => handleDelete(types.multiple)}
            >
              <Delete style={{ color: "red" }} />
              Delete
            </Button>
          ) : (
            ""
          )}

          <Button variant="outlined" onClick={() => navigate("/createAppoint")}>
            <Add />
            Create Appointment
          </Button>
        </div>
      </div>

      <TextField
        id="outlined-basic"
        variant="outlined"
        InputProps={{
          style: {
            borderRadius: "12px",
            border: "none",
            backgroundColor: "#F8F8F9",
            height: "56px",
          },
          autoComplete: "off",
        }}
        sx={{ width: "100%" }}
        placeholder="Search"
        onChange={(e) => {
          seChngetPage(1);
          setSearchText(e.target.value);
        }}
        value={searchText}
        autoComplete="off"
      />
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center",
          marginTop: "12px",
        }}
      >
        <TextField
          type="date"
          label="From"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={fromDate}
          onChange={(e) => {
            seChngetPage(1);
            setFromDate(e.target.value);
          }}
        />
        <TextField
          type="date"
          label="To"
          size="small"
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: fromDate || undefined }}
          value={toDate}
          onChange={(e) => {
            seChngetPage(1);
            setToDate(e.target.value);
          }}
        />
        {(fromDate || toDate) && (
          <Button
            variant="outlined"
            onClick={() => {
              seChngetPage(1);
              setFromDate("");
              setToDate("");
            }}
          >
            Clear dates
          </Button>
        )}
      </div>
      {loader ? (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: "5%" }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {allAppointment?.length > 0 ? (
            <>
              {isCompactLayout ? (
                <>
                  <Box
                    sx={{
                      mt: 1.5,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    <Typography sx={{ color: "#808191", fontSize: "0.875rem" }}>
                      Selected on page: {allId.length}
                    </Typography>
                    <Button size="small" onClick={selectAll}>
                      {allId.length === allAppointment.length
                        ? "Clear selection"
                        : "Select all"}
                    </Button>
                  </Box>
                  <Stack spacing={2} sx={{ mt: 2 }}>
                    {allAppointment?.map((row, index) => {
                      const vehicleSummary = row?.vehicle?.imageURL
                        ? `${row?.vehicle?.tekmetricRaw?.make || ""} ${row?.vehicle?.tekmetricRaw?.model || ""} ${row?.vehicle?.tekmetricRaw?.year || ""}`.trim()
                        : "New Car";

                      return (
                        <ResponsiveEntityCard
                          key={row?._id || index}
                          selectionControl={
                            <Checkbox
                              {...label}
                              checked={allId.includes(row?._id)}
                              size="small"
                              onChange={() => changCheckBox(row)}
                            />
                          }
                          media={
                            <Box
                              component="img"
                              src={row?.vehicle?.imageURL ? row?.vehicle?.imageURL : NewCar}
                              alt={vehicleSummary || "Vehicle"}
                              sx={{
                                width: 72,
                                height: 48,
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                            />
                          }
                          title={vehicleSummary}
                          subtitle={moment(row?.appointmentAt).format("DD MMM, YYYY h:mm a")}
                          fields={[
                            {
                              label: "Owned By",
                              value:
                                row?.user?.fullName ||
                                row?.guestUserInfo?.fullName ||
                                "—",
                            },
                            {
                              label: "Mileage",
                              value: row?.vehicle
                                ? row?.vehicle?.mileage / 1000 + "KM"
                                : "--",
                            },
                            {
                              label: "Appointment Reason",
                              value: row?.description,
                              fullWidth: true,
                            },
                          ]}
                          actions={renderCompactAppointmentActions(row, index)}
                        />
                      );
                    })}
                  </Stack>
                </>
              ) : (
                <TableContainer
                  className="tabledContainer"
                  sx={{
                    marginTop: "2%",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Checkbox
                            checked={allId.length ? true : false}
                            onChange={() => selectAll()}
                            {...label}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>Vehicle Details (Make,Model,Year)</TableCell>
                        <TableCell>Owned By</TableCell>
                        <TableCell>Milage (KMs)</TableCell>
                        <TableCell>Appointment Reason</TableCell>
                        <TableCell>Appointment Time</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allAppointment?.map((row, index) => (
                        <>
                          <TableRow key={index}>
                            <TableCell>
                              <Checkbox
                                {...label}
                                checked={allId.includes(row?._id)}
                                size="small"
                                onChange={() => changCheckBox(row)}
                              />
                            </TableCell>
                            <TableCell>
                              <div className="tableNameDiv">
                                <img
                                  src={
                                    row?.vehicle?.imageURL
                                      ? row?.vehicle?.imageURL
                                      : NewCar
                                  }
                                  height="50"
                                  width={"100"}
                                />
                                {row?.vehicle?.imageURL ? (
                                  <div style={{ marginLeft: "10%" }}>
                                    <div className="taleName">
                                      {row?.vehicle?.tekmetricRaw?.make}{" "}
                                      {row?.vehicle?.tekmetricRaw?.model}{" "}
                                      {row?.vehicle?.tekmetricRaw?.year}
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ marginLeft: "10%" }}>
                                    <div className="taleName">New Car</div>
                                  </div>
                                )}
                              </div>
                            </TableCell>

                            <TableCell>
                              {row?.user?.fullName ||
                                row?.guestUserInfo?.fullName ||
                                "—"}
                            </TableCell>
                            <TableCell>
                              {row?.vehicle
                                ? row?.vehicle?.mileage / 1000 + "KM"
                                : "--"}
                            </TableCell>
                            <TableCell>{row?.description}</TableCell>
                            <TableCell>
                              {moment(row?.appointmentAt).format(
                                "DD MMM, YYYY h:mm a"
                              )}
                            </TableCell>
                            <TableCell>
                              <div style={{ display: "flex" }}>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    minWidth: "45px",
                                    width: "35px",
                                    height: "40px",
                                    borderColor: "#c8bcbc !important",
                                    "&:hover": {
                                      background: "#FEE8CE",
                                    },
                                  }}
                                  onClick={() => handleClickOpenDetail(row)}
                                >
                                  <Visibility style={{ color: "#FD8A25" }} />
                                </Button>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    marginLeft: "5%",
                                    marginRight: "5%",
                                    minWidth: "45px",
                                    width: "35px",
                                    height: "40px",
                                    borderColor:
                                      "rgba(255, 183, 190, 0.9) !important",
                                    "&:hover": {
                                      background: " rgba(255, 183, 190, 0.9);",
                                    },
                                  }}
                                  onClick={() => {
                                    setDelIndx(index);
                                    handleDelete(types.single, row?._id);
                                  }}
                                >
                                  {delLoader && index == delIndx ? (
                                    <Loader colors={"red"} />
                                  ) : (
                                    <Delete style={{ color: "red" }} />
                                  )}
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              <Pagination
                listSize={totalCount}
                page={active}
                setPage={setActive}
                seChngetPage={seChngetPage}
                lastPage={lastPage}
              />
              {/* <Pagination
                lastPage={lastPage}
                active={active}
                setActive={setActive}
              /> */}
            </>
          ) : (
            <div className="flexCard" style={{ marginTop: "10%" }}>
              <img src={NoData} />
            </div>
          )}
        </>
      )}
      <ViewDetail
        setDetail={setAppointmentDetail}
        detail={appointmentDetail}
        open={openDetail}
        handleClose={handleCloseDetail}
        appointMentPlaceHolder={
          "https://app.integrity1auto.com/static/media/new_car.c806dc8f50ba8655f8393085e13f112f.svg"
        }
      />
    </>
  );
}
